import React from 'react'
import PropTypes from 'prop-types'

/**
 * Sidebar mobile
 */
function SidebarDesktop ({ children, logo }) {
  return (
    <div className='hidden md:flex md:flex-shrink-0'>
      <div className='flex flex-col w-64 bg-white py-8'>
        <div className='flex items-center flex-shrink-0 px-8'>
          {logo}
        </div>
        <div className='h-0 flex-1 flex flex-col overflow-y-auto'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default SidebarDesktop
